/**
 * extractApiError — единое извлечение человекочитаемого сообщения из API-ошибки.
 *
 * Backend (main.py http_exception_handler) возвращает ошибки в форме:
 *   { "error": { "code": 400, "message": "...", "path": "..." } }
 * Раньше UI читал `response.data.detail` (FastAPI-форма по умолчанию), которого
 * в унифицированном ответе нет → пользователь видел generic axios
 * «Request failed with status code 400» вместо полезного сообщения.
 *
 * Порядок: унифицированный `error.message` → legacy `detail` → axios message.
 */
export function extractApiError(err: unknown, fallback?: string): string {
  if (!err) return fallback ?? '';
  const e = err as {
    response?: { data?: { error?: { message?: string }; detail?: string } };
    message?: string;
  };
  const unified = e?.response?.data?.error?.message;
  if (unified && typeof unified === 'string') return unified;
  const detail = e?.response?.data?.detail;
  if (detail && typeof detail === 'string') return detail;
  if (e?.message && typeof e.message === 'string') return e.message;
  return fallback ?? 'Request failed';
}